import React, { useState, useEffect } from 'react';
import { Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { ServiceExtendedArea } from "../../../components/ServiceArea/ServiceArea.js";
import { Link as RouterLink } from "react-router-dom";
import * as Scroll from 'react-scroll';
import API from '../../../api/api';
import { getImageUrl } from '../../../utils/imageUtils';
import { SERVICES_PAGE_INTRO, sortServices } from '../../../content/servicesCatalog';

const garageApi = new API();
const scroller = Scroll.scroller;

function serviceAnchor(unikey) {
  return unikey ? String(unikey).split('-')[0] : '';
}

export default function ServicesSection(props) {
  const [services, setServices] = useState([]);
  const [snackBar, setSnackBar] = useState(false);
  const [loadingServices, setLoadingServices] = useState(false);

  useEffect(() => {
    garageApi.openEndpoints.services.getAll()
      .then((servicesGET) => {
        try {
          let servicesData = [];
          if (servicesGET && servicesGET.data) {
            if (Array.isArray(servicesGET.data)) {
              servicesData = servicesGET.data;
            } else if (servicesGET.data.results && Array.isArray(servicesGET.data.results)) {
              servicesData = servicesGET.data.results;
            }
          }

          setServices(sortServices(servicesData));
          setLoadingServices(true);

          if (props.scrollTo) {
            window.setTimeout(() => {
              scroller.scrollTo(props.scrollTo, {
                duration: 500,
                delay: 50,
                smooth: true,
                offset: -96,
              });
            }, 80);
          }
        }
        catch (e) {
          setServices([]);
          setSnackBar(true);
        }
      })
      .catch(() => {
        setServices([]);
        setLoadingServices(true);
      });
  }, [props.scrollTo]);

  function closeSnackBar(event, reason) {
    if (reason === 'clickaway') {
      return;
    }
    setSnackBar(false);
  }

  return (
    <div className="spg-service-page">
      <Snackbar open={snackBar} autoHideDuration={6000} onClose={closeSnackBar}>
        <MuiAlert elevation={6} variant="filled" onClose={closeSnackBar} severity="warning">
          Server Fehler 500
        </MuiAlert>
      </Snackbar>

      <section className="spg-section spg-service-intro">
        <div className="spg-kicker">Werkstatt Davos</div>
        <h2 className="spg-title">{SERVICES_PAGE_INTRO.title}</h2>
        <p className="spg-lead">{SERVICES_PAGE_INTRO.lead}</p>
        <RouterLink className="spg-btn" to="/online-termin">Termin anfragen</RouterLink>
      </section>

      {loadingServices && Array.isArray(services) && services.length > 1 ? (
        <nav className="spg-service-nav" aria-label="Leistungen">
            {services.map((service, index) => (
              <a
                key={service.unikey || index}
                href={`#${serviceAnchor(service.unikey)}`}
                onClick={(event) => {
                  event.preventDefault();
                  scroller.scrollTo(serviceAnchor(service.unikey), {
                    duration: 450,
                    smooth: true,
                    offset: -96,
                  });
                }}
              >
                {service.title}
              </a>
            ))}
          </nav>
      ) : null}

      <div className="spg-service-list">
        {loadingServices ? (
          Array.isArray(services) && services.length > 0 ? services.map((service, index) => (
            <ServiceExtendedArea
              key={service.unikey || index}
              index={index}
              title={service.title}
              description={service.description}
              text={service.text}
              image={service.image ? getImageUrl(service.image, 'large') || '' : ''}
              unikey={service.unikey}
            />
          )) : null
        ) : (
          Array.from({ length: 3 }, (_, i) => (
            <article key={i} className="spg-service-row is-loading">
              <div className="spg-service-visual is-empty" />
              <div className="spg-service-copy">
                <span className="spg-service-index">{String(i + 1).padStart(2, '0')}</span>
                <div className="spg-service-skel" />
                <div className="spg-service-skel is-wide" />
              </div>
            </article>
          ))
        )}
      </div>
    </div>
  );
}
